module.exports = __webpack_public_path__ + "static/WhenThePastWasAround2-7cf3000bf0edfe7ec245048c0f34e5c3.webp";